// Articles du blog. Contenu en mini-markdown (voir md() dans BlogPost.jsx). Prix : uniquement des repères sourcés.
export const BLOG_POSTS = [
  {
    slug: "demoussage-toiture-prix-regles",
    title: "Démoussage de toiture : prix, fréquence et autorisation",
    metaTitle: "Démoussage de toiture : prix, fréquence, autorisation",
    category: "Entretien",
    readTime: "6 min",
    date: "2026-10-13",
    updated: "2026-10-13",
    excerpt: "Un démoussage coûte en général de 25 à 35 € le m², et aucune autorisation n'est nécessaire tant que l'aspect de la toiture ne change pas. Prix, méthode et fréquence.",
    faq: [
      { q: "Faut-il une déclaration préalable pour démousser un toit ?", a: "Non, le nettoyage et le démoussage d'une toiture à l'identique ne demandent pas de déclaration préalable. Elle devient nécessaire si les travaux modifient l'aspect extérieur, par exemple un changement de couleur." },
      { q: "Quel est le prix d'un démoussage au m² ?", a: "Les guides publics indiquent de 25 à 35 € le m² pour un démoussage, et de 35 à 45 € le m² avec un hydrofuge." },
      { q: "À quelle fréquence démousser une toiture ?", a: "Cela dépend de l'exposition et de l'humidité. En Normandie, les versants au nord et à l'ombre des arbres se recouvrent plus vite : un contrôle visuel chaque année permet de décider." },
    ],
    content: `Un démoussage de toiture coûte en général de 25 à 35 € le m², et de 35 à 45 € le m² si un hydrofuge est appliqué dans la foulée. Aucune autorisation n'est nécessaire tant que l'aspect de la toiture ne change pas. Ces repères viennent de guides publics cités en fin d'article ; le prix de votre toit est donné par un devis gratuit.

## Quel est le prix d'un démoussage de toiture ?

| Prestation | Repère de prix |
|---|---|
| Démoussage seul | 25 à 35 € le m² |
| Démoussage et hydrofuge | 35 à 45 € le m² |
| Hydrofuge seul | 1 500 à 3 500 € pour 100 m² |

Ces montants varient avec la surface, la pente, l'accès au toit et l'état des tuiles. Un toit très encrassé ou difficile d'accès coûte plus cher. Pour le détail de la prestation, consultez la page [démoussage de toiture à Caen](/demoussage-toiture-caen) et notre page [tarifs](/tarifs-couvreur-caen).

## Pourquoi démousser sa toiture ?

La mousse et les lichens retiennent l'eau sur les tuiles et les ardoises. Cette humidité permanente accélère leur vieillissement et peut finir par provoquer des infiltrations. Dans le Calvados, le climat océanique rend ce phénomène fréquent, surtout sur les pans orientés au nord.

## Faut-il une autorisation pour démousser ?

Non, tant que le démoussage laisse la toiture identique. Le service public rappelle qu'une déclaration préalable de travaux est exigée lorsque l'aspect extérieur change. Un hydrofuge coloré qui modifie la teinte du toit peut donc être concerné : renseignez-vous auprès de la mairie, en particulier dans un secteur protégé.

## Comment se déroule un démoussage ?

1. Examen de la toiture et repérage des tuiles abîmées.
2. Nettoyage de la mousse et des lichens, à la main et à l'eau.
3. Traitement fongicide pour ralentir la repousse.
4. Remplacement des tuiles cassées si nécessaire.
5. Application d'un hydrofuge, en option.

## À quelle fréquence faut-il démousser ?

Il n'existe pas de durée fixe : tout dépend de l'exposition, de la proximité des arbres et de l'humidité. Un coup d'œil chaque année, depuis le sol ou avec des jumelles, permet de repérer les premières taches vertes avant qu'elles ne s'étendent.

## Peut-on démousser soi-même ?

Monter sur un toit présente un risque de chute, et un nettoyage trop agressif à la haute pression abîme les tuiles. Pour un toit en pente, il est plus sûr de confier le travail à un couvreur.

## Sources

- La Maison Saint-Gobain, guide « Prix d'un nettoyage de toiture au m² », mis à jour le 10 mars 2026.
- [justice.fr, travaux de réparation de toiture : faut-il une autorisation d'urbanisme ?](https://www.justice.fr/fiche/autorisation-urbanisme-deposer-faire-travaux-reparation-toiture)

Pour faire examiner votre toiture, [demandez un devis gratuit](/contact).`,
  },
  {
    slug: "fuite-toiture-que-faire-prix",
    title: "Fuite de toiture : que faire et combien ça coûte ?",
    metaTitle: "Fuite de toiture : que faire et quel prix de réparation",
    category: "Réparation",
    readTime: "6 min",
    date: "2026-10-13",
    updated: "2026-10-13",
    excerpt: "Face à une fuite de toiture, protégez d'abord l'intérieur puis faites repérer l'origine. La réparation coûte en général de 400 à 2 500 €, selon les guides de prix.",
    faq: [
      { q: "Que faire en cas de fuite de toiture ?", a: "Placez un récipient sous la fuite, protégez les meubles, coupez l'électricité si l'eau touche une installation, prenez des photos et appelez un couvreur pour repérer l'origine." },
      { q: "Combien coûte la réparation d'une fuite de toit ?", a: "Les guides publics indiquent de 400 à 2 500 €, avec une moyenne autour de 750 €. Remplacer une ou deux tuiles revient de 150 à 250 € TTC." },
      { q: "Faut-il prévenir son assurance ?", a: "Oui, en général. Déclarez le sinistre à votre assurance habitation dans les délais de votre contrat et conservez photos et devis." },
    ],
    content: `Face à une fuite de toiture, protégez d'abord l'intérieur du logement, puis faites repérer l'origine par un couvreur. La réparation coûte en général de 400 à 2 500 €, avec une moyenne autour de 750 €, d'après les guides de prix cités en fin d'article.

## Que faire en cas de fuite de toiture ?

1. Placez un récipient sous l'écoulement et déplacez les meubles.
2. Si l'eau touche un luminaire ou une prise, coupez le courant au tableau.
3. Photographiez les dégâts à l'intérieur : ils serviront à l'assurance.
4. N'essayez pas de monter sur le toit par temps de pluie ou de vent.
5. Appelez un couvreur pour repérer l'origine et sécuriser la zone.

## D'où vient une fuite de toiture ?

L'endroit où l'eau tombe n'est pas toujours celui où elle entre : elle peut suivre une charpente avant d'apparaître. Les causes les plus fréquentes sont :

- des tuiles cassées, déplacées ou poreuses ;
- un faîtage dont le mortier s'est dégradé ;
- des solins autour d'une cheminée ou d'un Velux ;
- une gouttière bouchée ou une noue encrassée.

Voir la page [réparation de toiture à Caen](/reparation-toiture-caen).

## Combien coûte une réparation de fuite ?

| Intervention | Repère de prix |
|---|---|
| Réparation d'une fuite | 400 à 2 500 € (environ 750 € en moyenne) |
| Remplacement d'une ou deux tuiles | 150 à 250 € TTC |
| Remplacement de plusieurs tuiles | 70 à 150 € le m² |
| Réfection du faîtage | 50 à 150 € le mètre linéaire |
| Reprise d'un solin | 300 à 1 000 € |

Le prix dépend de l'accès, de la hauteur et de l'étendue des dégâts. Voir aussi nos [tarifs](/tarifs-couvreur-caen).

## Faut-il prévenir son assurance ?

En général oui : déclarez le sinistre à votre assurance habitation dans les délais prévus par votre contrat, avec les photos et le devis du couvreur. La prise en charge dépend de votre contrat et de la cause de la fuite.

## Réparer ou refaire la toiture ?

Quand le désordre est localisé et le reste de la couverture en bon état, une réparation ciblée suffit. Si les tuiles sont poreuses ou les fuites répétées sur plusieurs zones, une [rénovation de toiture](/renovation-toiture-caen) peut être plus pertinente. Seul l'examen de la toiture permet de trancher.

## Sources

- MesDépanneurs, guide « Fuite de toiture ? Les prix de réparation », mis à jour le 30 décembre 2025.

Pour faire repérer l'origine d'une fuite, [demandez un devis gratuit](/contact).`,
  },
  {
    slug: "prix-toiture-m2-tuiles-ardoises-zinc",
    title: "Prix d'une toiture au m² : tuiles, ardoises, zinc",
    metaTitle: "Prix d'une toiture au m² : tuiles, ardoises, zinc",
    category: "Rénovation",
    readTime: "5 min",
    date: "2026-10-14",
    updated: "2026-10-14",
    excerpt: "Une couverture neuve coûte en général de 90 € le m² en tuiles béton à 200 € le m² en ardoises naturelles, dépose comprise en plus. Comparatif sourcé.",
    faq: [
      { q: "Combien coûte une toiture neuve au m² ?", a: "Les guides publics indiquent environ 90 € le m² en tuiles béton, 125 € en zinc, 130 € en terre cuite et 200 € en ardoises naturelles, prix TTC fourni et posé." },
      { q: "Combien coûte la dépose de l'ancienne couverture ?", a: "Compter environ 15 € le m² pour déposer l'ancienne couverture, en plus du prix de la nouvelle." },
      { q: "Comment obtenir le prix exact ?", a: "Le prix dépend de la surface, de la pente, de l'accès et de l'état de la charpente. Un devis gratuit après examen de la toiture donne le montant de votre chantier." },
    ],
    content: `Une couverture neuve coûte en général d'environ 90 € le m² en tuiles béton à environ 200 € le m² en ardoises naturelles, prix TTC fourni et posé. La dépose de l'ancienne couverture s'ajoute, autour de 15 € le m². Ces repères viennent d'un guide public cité en fin d'article ; votre devis donne le prix réel.

## Quel est le prix d'une toiture au m² selon le matériau ?

| Matériau | Repère de prix TTC |
|---|---|
| Tuiles béton | environ 90 € le m² |
| Zinc | environ 125 € le m² |
| Tuiles terre cuite | environ 130 € le m² |
| Ardoises naturelles | environ 200 € le m² |
| Dépose de l'ancienne couverture | environ 15 € le m² |

## Pourquoi le prix varie-t-il autant ?

La pente, la hauteur du bâtiment, l'accès pour l'échafaudage, le nombre de points singuliers (cheminées, lucarnes, noues) et l'état de la charpente changent le chantier. Une toiture simple coûte moins cher qu'une toiture découpée.

## Quel matériau choisir à Caen ?

La tuile et l'ardoise sont les plus répandues dans le Calvados. Le choix dépend du style de la maison, des règles d'urbanisme locales et du budget. En secteur protégé, l'aspect de la couverture est encadré : renseignez-vous auprès de la mairie.

## Faut-il refaire toute la toiture ?

Pas toujours. Si le désordre est localisé, une [réparation de toiture](/reparation-toiture-caen) suffit. Si les tuiles sont poreuses ou la mousse envahissante, un [démoussage](/demoussage-toiture-caen) peut retarder la rénovation. Quand la couverture est en fin de vie, la [rénovation de toiture](/renovation-toiture-caen) devient pertinente. Voir aussi nos [tarifs](/tarifs-couvreur-caen).

## Sources

- La Maison Saint-Gobain, guide « Quel prix pour votre rénovation de toiture ? », mis à jour le 16 avril 2026 (prix TTC).

Pour connaître le prix de votre toiture, [demandez un devis gratuit](/contact).`,
  },
  {
    slug: "pose-velux-prix-autorisation",
    title: "Pose d'un Velux : prix et autorisation à prévoir",
    metaTitle: "Pose d'un Velux : prix et autorisation à prévoir",
    category: "Fenêtres de toit",
    readTime: "5 min",
    date: "2026-10-14",
    updated: "2026-10-14",
    excerpt: "La pose d'un Velux coûte environ 300 € de main-d'œuvre, plus le prix de la fenêtre (240 à 1 300 €). Une déclaration préalable est en général nécessaire.",
    faq: [
      { q: "Combien coûte la pose d'un Velux ?", a: "Environ 300 € pour la pose, auxquels s'ajoute le prix de la fenêtre de toit, de 240 à 1 300 € selon le modèle, d'après les guides publics." },
      { q: "Faut-il une autorisation pour poser une fenêtre de toit ?", a: "En général oui : l'ajout d'une fenêtre de toit modifie l'aspect extérieur et demande une déclaration préalable de travaux en mairie. Vérifiez auprès de votre mairie." },
      { q: "Peut-on remplacer un Velux existant ?", a: "Oui. Le remplacement de la fenêtre et de ses raccords d'étanchéité fait partie des interventions courantes d'un couvreur." },
    ],
    content: `La pose d'un Velux coûte environ 300 € de main-d'œuvre, auxquels s'ajoute le prix de la fenêtre de toit, de 240 à 1 300 € selon le modèle. Une déclaration préalable de travaux est en général nécessaire quand on crée une nouvelle ouverture. Repères issus de guides publics, cités en fin d'article.

## Combien coûte la pose d'un Velux ?

| Poste | Repère de prix |
|---|---|
| Pose d'une fenêtre de toit | environ 300 € |
| Fenêtre de toit (fourniture) | 240 à 1 300 € |

Le prix final dépend du modèle (ouverture, motorisation, taille), de la découpe de la couverture et des raccords d'étanchéité autour de la fenêtre.

## Faut-il une autorisation pour poser une fenêtre de toit ?

Créer une ouverture dans la toiture modifie l'aspect extérieur de la maison. Une déclaration préalable de travaux est donc en général demandée en mairie, avant le chantier. Les règles peuvent être plus strictes en secteur protégé : renseignez-vous auprès du service urbanisme de votre commune.

## Pourquoi l'étanchéité est-elle le point clé ?

Une fenêtre de toit est un point sensible : les solins et raccords autour du cadre doivent être posés avec soin. Une mauvaise pose provoque des infiltrations. Voir la page [pose de Velux à Caen](/pose-velux-caen) et celle de l'[étanchéité de toiture](/etancheite-toiture-caen).

## Sources

- La Maison Saint-Gobain, guide « Quel prix pour votre rénovation de toiture ? », mis à jour le 16 avril 2026.
- [justice.fr, faut-il une autorisation d'urbanisme pour installer une fenêtre de toit ?](https://www.justice.fr/fiche/autorisation-urbanisme-faut-deposer-installer-fenetre-toit)

Pour un devis de pose ou de remplacement, [contactez-nous](/contact).`,
  },
  {
    slug: "gouttieres-entretien-reparation-prix",
    title: "Gouttières : entretien, réparation et prix",
    metaTitle: "Gouttières : entretien, réparation et prix",
    category: "Zinguerie",
    readTime: "4 min",
    date: "2026-10-14",
    updated: "2026-10-14",
    excerpt: "Le nettoyage d'une gouttière coûte de 12 à 25 € le mètre linéaire et une réparation de 150 à 225 €. Quand et comment entretenir ses gouttières.",
    faq: [
      { q: "Combien coûte le nettoyage d'une gouttière ?", a: "De 12 à 25 € le mètre linéaire selon les guides publics." },
      { q: "Combien coûte la réparation d'une gouttière ?", a: "Compter de 150 à 225 € pour une réparation, selon l'étendue des dégâts." },
      { q: "Quand nettoyer ses gouttières ?", a: "Après la chute des feuilles et après les tempêtes, pour éviter les débordements et les infiltrations en façade." },
    ],
    content: `Le nettoyage d'une gouttière coûte de 12 à 25 € le mètre linéaire, et une réparation de 150 à 225 €. Des gouttières bouchées font déborder l'eau sur la façade et les murs. Repères tirés d'un guide public cité en fin d'article.

## Quel est le prix d'entretien et de réparation d'une gouttière ?

| Intervention | Repère de prix |
|---|---|
| Nettoyage de gouttière | 12 à 25 € le mètre linéaire |
| Réparation de gouttière | 150 à 225 € |

## Pourquoi entretenir ses gouttières ?

Feuilles, mousse et sédiments bouchent les gouttières et les descentes. L'eau déborde, abîme la façade et peut remonter sous les tuiles. Un nettoyage après l'automne évite ces désordres.

## Quels signes montrent un problème ?

- de l'eau qui déborde par temps de pluie ;
- des traces vertes ou noires sur la façade sous la gouttière ;
- des joints qui fuient ou une gouttière qui penche ;
- de la végétation qui pousse dans le chéneau.

## Que peut faire un couvreur zingueur ?

Nettoyage, remplacement de tronçons, reprise des joints et pose de gouttières neuves. Voir la page [gouttières à Caen](/gouttieres-caen) et celle du [couvreur zingueur](/couvreur-zingueur-caen).

## Sources

- MesDépanneurs, guide « Fuite de toiture ? Les prix de réparation », mis à jour le 30 décembre 2025.

Pour faire examiner vos gouttières, [demandez un devis gratuit](/contact).`,
  },
  {
    slug: "traitement-charpente-xylophages-prix",
    title: "Traitement de charpente : prix et signes d'alerte",
    metaTitle: "Traitement de charpente : prix et signes d'alerte",
    category: "Charpente",
    readTime: "4 min",
    date: "2026-10-14",
    updated: "2026-10-14",
    excerpt: "Le traitement contre les xylophages coûte de 30 à 50 € le mètre linéaire. Les signes d'une charpente attaquée et les prix de réparation.",
    faq: [
      { q: "Combien coûte un traitement de charpente ?", a: "Le traitement contre les xylophages revient de 30 à 50 € le mètre linéaire selon les guides publics." },
      { q: "Combien coûte la réparation d'une charpente ?", a: "Environ 60 € le m² pour une réparation, et environ 188 € le m² pour un remplacement complet de charpente." },
      { q: "Comment repérer une charpente attaquée ?", a: "Petits trous de sortie, poussière de bois sous les pièces, bois qui sonne creux ou s'effrite : faites contrôler la charpente par un professionnel." },
    ],
    content: `Le traitement d'une charpente contre les xylophages coûte de 30 à 50 € le mètre linéaire. Une réparation revient à environ 60 € le m², et un remplacement complet à environ 188 € le m². Ces prix viennent d'un guide public cité en fin d'article.

## Quels sont les prix pour une charpente ?

| Intervention | Repère de prix TTC |
|---|---|
| Traitement contre les xylophages | 30 à 50 € le mètre linéaire |
| Réparation de charpente | environ 60 € le m² |
| Remplacement de charpente | environ 188 € le m² |

## Comment repérer une charpente attaquée ?

Des petits trous de sortie, de la poussière de bois sous les pièces, un bois qui sonne creux ou qui s'effrite sont des signes d'alerte. L'humidité due à une fuite favorise aussi les champignons.

## Pourquoi traiter vite ?

Un bois attaqué perd de sa solidité. Un diagnostic permet de choisir entre un traitement et la reprise des pièces abîmées. Voir la page [traitement de charpente à Caen](/traitement-charpente-caen).

## Sources

- La Maison Saint-Gobain, guide « Quel prix pour votre rénovation de toiture ? », mis à jour le 16 avril 2026 (prix TTC).

Pour faire contrôler votre charpente, [demandez un devis gratuit](/contact).`,
  },
];

export const getPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
